var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content finance-report" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { lazy: true, type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "Finance Report", name: "financeReport" } },
              [
                _c("tab-finance-report", {
                  ref: "financeReport",
                  attrs: {
                    "copy-month-list": _vm.copyMonthList,
                    "latest-monthly-date": _vm.latestMonthlyDate
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v("O ")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }